import _ from 'lodash'
import * as NUMBER from 'constant/number'
import * as XLSX_CONSTANT from 'constant/xlsx'

export const formatData = (articles) =>
  _.map(articles, (article) =>
    _.reduce(article, (accumulator, value, key) => {
      const newKey = _.startCase(key)

      if (XLSX_CONSTANT.ARRAY_COLUMNS.some((column) => column === key)) {
        const colValue = value.reduce((accumulator, { name }) => accumulator + `${name}, `, '')
        accumulator[newKey] = colValue.substring(NUMBER.ZERO, colValue.length - NUMBER.TWO)
      } else if (XLSX_CONSTANT.NAMED_COLUMNS.some((column) => column === key)) {
        accumulator[newKey] = value.name
      } else if (XLSX_CONSTANT.LITERAL_COLUMNS.some((column) => column === key)) {
        accumulator[newKey] = value
      }

      return accumulator
    }, {})
  )

export const getColWidths = (data) =>
  _.keys(data[NUMBER.ZERO]).reduce((result, key) => {
    const value = data.sort((a, b) => {
      return b[key] === null || a[key] === null ? NUMBER.ONE : b[key].length - a[key].length
    })[0][key]

    const width = value.length > key.length ? value.length : key.length
    result.push({ width: width > NUMBER.TWO_HUNDRED ? NUMBER.TWO_HUNDRED : width + NUMBER.TWO })
    return result
  }, [])
